import React from 'react';
import { withRouter } from 'react-router-dom';
import Content from "../../../../components/layout/Content";
import {MobileInfoItem} from "../../../../components/utils/MobileInfoItem";
import { MEASURES_RAW } from '../../../../containers/rawmaterials/constansts';
import { parseNumToFixed } from '../../../../utils/common';
import moment from 'moment';

const Item = ({ item, isMobile }) => {
    if (isMobile) {
        return (
            <tr key={item.id} className="kt-datatable__row">
                <td colSpan="100%" className="kt-datatable__cell">
                    <div style={{ padding: '0.5rem 1rem' }}>
                        <div style={{
                            fontSize: '0.9rem',
                            marginBottom: '0.75rem',
                            fontWeight: 600,
                            letterSpacing: '0.05em',
                            textTransform: 'uppercase',
                            whiteSpace: 'nowrap',
                            overflow: 'hidden',
                            textOverflow: 'ellipsis'
                        }}>
                            {item.name}, {MEASURES_RAW[item.measure] || ''}
                        </div>
                        <div style={{
                            display: 'flex',
                            flexWrap: 'nowrap',
                            gap: '0.75rem',
                            overflowX: 'auto',
                            paddingBottom: '0.5rem',
                            marginRight: '-1rem',
                            alignItems: 'flex-start'
                        }}>
                            <MobileInfoItem
                                label="Количество"
                                value={parseNumToFixed(item.quantity, 3) || 0}
                            />
                            <MobileInfoItem
                                label="Дата реализации"
                                value={item.dateRealization ? moment(item.dateRealization).format('DD.MM.YYYY HH:mm') : '-'}
                            />
                            <MobileInfoItem
                                label="Цена"
                                value={parseNumToFixed(item.price) || 0}
                            />
                            <MobileInfoItem
                                label="Сумма"
                                value={parseNumToFixed(item.totalPrice) || 0}
                            />
                        </div>
                    </div>
                </td>
            </tr>
        )
    }

    return (
        <Content>
            <tr key={item.id} className="kt-datatable__row">
                <td width="200px" className="kt-datatable__cell">
                    <span>{item.name}</span>
                </td>
                <td style={{textAlign: 'left'}} width="auto" className="kt-datatable__cell">
                    <span>
                        {MEASURES_RAW[item.measure] || ''}
                    </span>
                </td>
                <td style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell">
                    <span>{item.dateRealization ? item.dateRealization : '-'}</span>
                </td>
                <td style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell">
                    <span>{parseNumToFixed(item.quantity, 3) || 0}</span>
                </td>
                <td style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell">
                    <span>{parseNumToFixed(item.price) || 0}</span>
                </td>
                <td style={{textAlign: 'center'}} width="120px" className="kt-datatable__cell">
                    <span>{parseNumToFixed(item.totalPrice) || 0}</span>
                </td>
            </tr>
        </Content>
    );
};

export const ItemRow = withRouter(Item);
